//Este enfoque te permite inyectar navigate en las props del componente de clase.

import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

const withNavigate = (WrappedComponent) => {
  // Create a functional component with the provided WrappedComponent
  const WithNavigateComponent = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    return <WrappedComponent {...props} navigate={navigate} location={location} params={params}/>;
  };

  // Set a displayName for the HOC
  WithNavigateComponent.displayName = `withNavigate(${WrappedComponent.displayName
    || WrappedComponent.name || 'Component'})`;

  return WithNavigateComponent;
};

export default withNavigate;
